export default function AdminPasswordRequests() {
  return (
    <div className="p-6">
      <div className="text-center py-12">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Password Reset Requests</h2>
        <div className="text-6xl mb-4">🔑</div>
        <p className="text-gray-600 mb-6">Manage user password reset requests</p>
        <p className="text-sm text-gray-500">Password management functionality coming soon...</p>
      </div>
    </div>
  );
}
